import {BehaviorSubject, Subject, filter, switchMap} from 'rxjs';
import {mockUtil} from '@/helper/moc';
import {mc} from '@/core';
import {lendingApi} from '@/api/lending';
import {wwData$} from '@/streams/worker-data';
import type {LendingAccountOriginRaw} from '@px/ws-data';

export const loadLendingAccountAssets$ = new Subject<void>();
export const lendingAccountAssets$ = new BehaviorSubject<LendingAccountOriginRaw[]>([]);

lendingAccountAssets$.subscribe((o) => {
  wwData$.next({
    type: 'lending-account-asset',
    data: o,
  });
});

if (!mockUtil.isMock()) {
  loadLendingAccountAssets$.pipe(switchMap(getAssets), filter(Boolean)).subscribe(lendingAccountAssets$);
}

async function getAssets(): Promise<LendingAccountOriginRaw[] | null> {
  const {data, error} = await lendingApi.getAssets({showAll: true});
  if (error) {
    mc.send('toast', 'error', error);
    return null;
  }
  return (data && data.rows) || null;
}
